import { useState, useEffect, useCallback, useMemo } from 'react'

import HistoryGrid from '../../../../components/GridPreview'

import HistoryGridSkeleton from '../HistoryGridSkeleton'
import { NavLink } from 'react-router-dom'
import Button from '../../../../components/Button'
import useGetFilters from '../../../../hooks/useGetAllTags'
import GrileService from '../../../../services/grile-service'

const SavedGridsTab = ({
  savedGrids,
  setSavedGrids,
  filteredSavedGrids,
  isLoading,
  colorByDifficulty,
  isNoteModalOpened,
  setIsNoteModalOpened,
  handleUpdateNote,
}) => {
  const { chapters } = useGetFilters()
  const [renderCount, setRenderCount] = useState(20)
  const [books, setBooks] = useState([])

  const handleConvertTagsId = useCallback(
    tagIds => {
      const tagNames = []
      for (let index = 0; index < tagIds.length; index++) {
        const tag = chapters?.find(tag => tag.id === tagIds[index])
        if (tag) {
          tagNames.push(tag.name)
        }
      }
      return tagNames
    },
    [chapters],
  )

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent =
        window.scrollY / (document.body.offsetHeight - window.innerHeight)
      if (scrollPercent > 0.8) {
        setRenderCount(current => current + 20)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    async function fetchBooks() {
      const books = await GrileService.getAllBooks()
      setBooks(books)
    }
    fetchBooks()
  }, [])

  const handleUnSaveGrid = useCallback(
    async id => {
      try {
        await GrileService.removeSavedGrid({
          grila_id: id,
        })
        const newSavedGrids = savedGrids.filter(grila => grila.id !== id)
        setSavedGrids(newSavedGrids)
      } catch (error) {
        console.error(error)
      }
    },
    [savedGrids, setSavedGrids],
  )

  const mappedFilteredGrids = useMemo(() => {
    if (savedGrids !== undefined && savedGrids.length === 0) {
      return (
        <div className="flex text-over-primary-background mt-16 flex-col justify-center items-center gap-3">
          <span>Nu ai salvat nicio grilă</span>{' '}
          <NavLink to="/grile">
            <Button className="bg-btn-primary">Către grile</Button>
          </NavLink>
        </div>
      )
    }

    if (filteredSavedGrids !== undefined && filteredSavedGrids.length === 0) {
      return (
        <div className="flex text-over-primary-background mt-16 flex-col justify-center items-center gap-3">
          <span>Nu există nicio grilă cu filtrele selectate</span>{' '}
        </div>
      )
    }

    return filteredSavedGrids?.slice(0, renderCount)?.map((grila, index) => {
      return (
        <HistoryGrid
          isMultipleChoice={grila?.multiple_choice}
          handleUpdateNote={handleUpdateNote}
          setIsNoteModalOpened={setIsNoteModalOpened}
          isNoteModalOpened={isNoteModalOpened}
          unSaveGrid={() => handleUnSaveGrid(grila.id)}
          percent={grila?.solving_time_percent}
          time={grila?.solving_time}
          key={`grila-${index}`}
          historyType={2}
          grilaId={grila?.id}
          cerinta={grila?.json}
          timestamp={grila?.timestamp}
          indiciu={grila?.hint}
          explicatie={grila?.explain}
          answer={grila?.correct_answer}
          userAnswer={grila?.choice}
          tags={handleConvertTagsId(grila?.tags)}
          dificulty={grila?.difficulty}
          source={grila?.source}
          difficulty={grila?.difficulty}
          colorByDifficulty={colorByDifficulty}
          note={grila?.note}
          pagesAuto={grila?.pages_auto}
          pagesManual={grila?.pages_manual}
          book={grila?.book}
          books={books}
          explainAnswers={JSON.parse(grila?.explain_answers)}
        />
      )
    })
  }, [
    handleConvertTagsId,
    renderCount,
    savedGrids,
    filteredSavedGrids,
    handleUpdateNote,
    colorByDifficulty,
    handleUnSaveGrid,
    isNoteModalOpened,
    setIsNoteModalOpened,
    books,
  ])

  return (
    <div className="sm:rounded sm:p-5 border border-brd-primary overflow-hidden overflow-x-hidden mb-[20px] mt-[10px] relative w-full !min-h-[75svh] bg-secondary-background rounded p-[10px]">
      {!isLoading &&
      filteredSavedGrids !== undefined &&
      savedGrids !== undefined
        ? mappedFilteredGrids
        : Array(10)
            .fill(0)
            .map((_, index) => <HistoryGridSkeleton key={index} />)}
    </div>
  )
}
export default SavedGridsTab
